/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Img } from '@/components/blocks/MaterialImage';
import { productImageBaseSX } from '@/components/blocks/ProductImage/styles/base';
import { productImageSelectedSX } from '@/components/blocks/ProductImage/styles/selected';
import { productImageTableCellSX } from '@/components/blocks/ProductImage/styles/tableCell';
import { productImageThumbnailSX } from '@/components/blocks/ProductImage/styles/thumbnail';
import { useDeviceType } from '@/data/deviceDetection';
import { useSettings } from '@/data/Settings';
import { combineSX } from '@/utils/combineSX';
import { SxProps, Theme } from '@mui/material';
import React  from 'react';
import { useWebPSupportCheck } from 'react-use-webp-support-check';

type Props = {
	src: string;
	alt: string;
	isThumbnail?: boolean;
	isSelected?: boolean;
	sx?: SxProps<Theme>;
	calledFrom?:string;
};

export const ProductImage: React.FC<Props> = ({ src, alt, isSelected, isThumbnail, sx, calledFrom = "UNKNOWN" }) => {
	const { settings } = useSettings();
	const {isMobile} = useDeviceType();
	const supportsWebP = useWebPSupportCheck();
	const isWebpON = settings.userData['isWebpON'];
	// TBD for all paths
	// const WebPImageOptimizedFolder = settings.userData['WebPImageOptimizedFolder'];
	let webpImage = '';

	// TODO later for webp
	if (supportsWebP && isWebpON) {
		if (isMobile) {
			webpImage = src?.replace('catalog/full', 'catalog/mobile-full-webp').replace('.jpg', '.webp');
		} else {
			if (isThumbnail) {
				webpImage = src?.replace('catalog/thumb', 'catalog/thumb-webp').replace('.jpg', '.webp');
			} else {
				webpImage = src?.replace('catalog/full', 'catalog/full-webp').replace('.jpg', '.webp');
			}
		}
	}
	
	src = `${settings.userData.StaticHostSecure}${src}`;

	return src ? (
		<>
			{ !isThumbnail && calledFrom!=="CarouselSlide"? 
				<a 	className="productImage MagicZoom" 
					id="pdpImage"
					//{...mzAnchorProps} 
					href={src} 
					data-options="autostart: false;expand:off;cssClass: mz-hide-arrows;"
					data-mobile-options="textClickZoomHint:Dubbeltik of knijp op de afbeelding om deze te vergroten;"
					tabIndex={-1} //to ignore main image from tab navigation
				>
					<Img
						sx={combineSX([
							productImageBaseSX,
							isThumbnail && productImageThumbnailSX,
							isSelected && productImageSelectedSX,
							sx,
						])}
						src={src}
						alt={alt}
						tabIndex={-1}
						/* onError={({ currentTarget }) => {
							currentTarget.onerror = null;
							currentTarget.src=`${settings.userData.StaticHostSecure}${src}`;
							}} */
					/>
				</a> 
				:
				<Img
					sx={combineSX([
						productImageBaseSX,
						isThumbnail && productImageThumbnailSX,
						isSelected && productImageSelectedSX,
						sx,
					])}
					src={src}
					alt={alt}
					tabIndex={-1}
					/* onError={({ currentTarget }) => {
						currentTarget.onerror = null;
						currentTarget.src=`${settings.userData.StaticHostSecure}${src}`;
						}} */
				/>
			}
		</>
	) : null;
};

export const TableCellProductImage: React.FC<Props> = ({
	src,
	alt,
	isSelected,
	isThumbnail,
	sx,
}) => (
	<ProductImage
		sx={combineSX([productImageTableCellSX, sx])}
		src={src}
		alt={alt}
		isSelected={isSelected}
		isThumbnail={isThumbnail}
	/>
);
